export default (invoiceFilters) => Object.keys(invoiceFilters).map(
  (key) => {
    if (Array.isArray(invoiceFilters[key])) {
      return invoiceFilters[key].length;
    }
    return invoiceFilters[key] ? 1 : 0;
  },
).reduce((partialSum, a) => partialSum + a, 0);
